(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[702],{

/***/ 3892:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thread/5-algorithms-to-sum-a-list-in-python",
      function () {
        return __webpack_require__(9449);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "meta": function() { return /* binding */ meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mdx_js_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1151);
/* harmony import */ var _layouts_TwitterThreadLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1075);
/* harmony import */ var _components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6833);
/*@jsxRuntime automatic @jsxImportSource react*/ 



const meta = {
    url: "https://devsforgood.com/thread/5-algorithms-to-sum-a-list-in-python",
    title: "5 algorithms to sum a list in Python",
    description: "Ever wondered what algorithm can sum a list/array the fastest in Python? Here's a surface level overview"
};
const MDXLayout = (param)=>{
    let { children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_TwitterThreadLayout__WEBPACK_IMPORTED_MODULE_1__/* .TwitterThreadLayout */ .T, {
        meta: meta,
        children: children
    });
};
function _createMdxContent(props) {
    const _components = Object.assign({
        p: "p"
    }, (0,_mdx_js_react__WEBPACK_IMPORTED_MODULE_3__/* .useMDXComponents */ .ah)(), props.components);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadAuthor */ .vI, {
                name: "Arsalan Ali",
                username: "arslanchaos",
                avatarUrl: "/avatars/arslanchaos.png"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadOriginalUrl */ .KN, {
                url: "https://twitter.com/arslanchaos/status/1578112367187173376"
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlockFirst */ .Iq, {
                image: "/images/5-algorithms-to-sum-a-list-in-python-0.png",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "Ever wondered what algorithm can sum a list/array the fastest in Python? Here's a surface level overview"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "A Thread \uD83E\uDDF5\uD83D\uDC47"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "#python3 #pythonic #pythonprogramming #programming #Algorithms #DataScience"
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/5-algorithms-to-sum-a-list-in-python-1.png",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: 'First of we generated a random list of "1000000" numbers to feed all the algorithms.'
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "This very first algorithm uses the built-in sum method. Its the easiest one to implement."
                    })
                ]
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/5-algorithms-to-sum-a-list-in-python-2.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                    children: "Second algorithm is just the traditional approach of creating a variable and\nthen using a for loop to add the sum into it."
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/5-algorithms-to-sum-a-list-in-python-3.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                    children: "Third algorithm isn't basically anything new. As a matter of fact its written\nto slow down the process because sum method already iterates on a list/array.\nSo giving it a for loop should slow it down. It's just for experimental\npurposes."
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/5-algorithms-to-sum-a-list-in-python-4.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                    children: "Fourth algorithm is based on reduce method. You need to specify some sort of\nfunction in it. You can use it without defining a function but for the sake of\nconsistency we've written it like this."
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/5-algorithms-to-sum-a-list-in-python-5.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                    children: "Lastly we've used the Numpy Sum method in the fifth algorithm."
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "/images/5-algorithms-to-sum-a-list-in-python-6.png",
                children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                    children: "As you can see from the results, Numpy Sum is the winner here. It beats the\nbuilt-in Sum method by quite a margin. Meanwhile our Sum Loop approach\nperforms the worst as expected. Reduce and Loop algorithms are almost similar\nin performance."
                })
            }),
            "\n",
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TwitterThread__WEBPACK_IMPORTED_MODULE_2__/* .TwitterThreadBlock */ .ji, {
                image: "undefined",
                children: [
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "Hope you liked the surface-level review and it helped you to choose the better algorithm for your project next time. \uD83D\uDE0A\uD83E\uDD73"
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components.p, {
                        children: "If you want more content like this, make sure to follow me."
                    })
                ]
            })
        ]
    });
}
function MDXContent() {
    let props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MDXLayout, Object.assign({}, props, {
        children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_createMdxContent, props)
    }));
}
/* harmony default export */ __webpack_exports__["default"] = (MDXContent);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4500,5675,2361,8411,9774,2888,179], function() { return __webpack_exec__(3892); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);